import type { InterludeTypes } from "@/interlude";

/**
 * Whether the available balance has reached the alert threshold the org set
 * under Billing, or is used up when no threshold is set.
 */
export const isBalanceLow = (
  availableBalance: number,
  threshold: number,
): boolean => availableBalance <= Math.max(threshold, 0);

/**
 * Active feature limits whose usage has reached the warning percentage the org
 * set for them. A limit without a usage percentage is never counted.
 */
export const getFeatureLimitsNearCap = (
  featureLimits: ReadonlyArray<InterludeTypes["FeatureLimit"]>,
): Array<InterludeTypes["FeatureLimit"]> =>
  featureLimits.filter(
    (limit) =>
      limit.isActive &&
      limit.usagePercent !== null &&
      limit.usagePercent >= limit.warningThresholdPercent,
  );
